const Categories = [
    require('./colorVariableCategories/categoryGeneral').default,
    require('./colorVariableCategories/categoryAdditional').default,
    require('./colorVariableCategories/categoryRibbons').default,
    require('./colorVariableCategories/categoryMessages').default,
];



export default Categories